import { render, staticRenderFns } from "./GoliveLandingPage.vue?vue&type=template&id=07f721d8&scoped=true"
import script from "./GoliveLandingPage.vue?vue&type=script&lang=js"
export * from "./GoliveLandingPage.vue?vue&type=script&lang=js"
import style0 from "./GoliveLandingPage.vue?vue&type=style&index=0&id=07f721d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f721d8",
  null
  
)

export default component.exports